import { Formik } from 'formik';
import { useCallback } from 'react';
import { object, string } from 'yup';

import { THREAD_SYSTEMS } from '@frontend/api';
import { Flex } from '@frontend/components';

import { SubFormProps } from '../types';
import { SubFormWrapper } from './shared/SubFormWrapper';
import {
  ThreadFieldGroup,
  buildThreadObject,
  type ThreadFieldValues,
} from './shared/ThreadFieldGroup';
import { createRequiredSelectField } from './shared/validation';

const initialValues: ThreadFieldValues = {
  threadSystem: THREAD_SYSTEMS.METRIC,
  size: '',
  pitch: '',
  threadDepth: '',
  toleranceClass: '',
  handedness: undefined,
};

const validationSchema = object().shape({
  threadSystem: createRequiredSelectField('Thread system'),
  size: string().required('Size is required'),
  pitch: string(),
  threadDepth: string(),
  toleranceClass: string(),
});

export const ThreadForm = ({
  onSubmit,
  onCancel,
  renderSelectedType,
}: SubFormProps) => {
  const handleSubmit = useCallback(
    (values: ThreadFieldValues) => {
      const { thread, rawThreadStr } = buildThreadObject(values);
      onSubmit(thread, rawThreadStr);
    },
    [onSubmit],
  );

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue, errors, touched, isValid, isSubmitting }) => (
        <SubFormWrapper
          isValid={isValid}
          isSubmitting={isSubmitting}
          onCancel={onCancel}
          renderSelectedType={renderSelectedType}
          submitLabel="Add Thread"
        >
          <Flex direction="column" gap={1} px={1} pb={1}>
            <ThreadFieldGroup
              values={values}
              onChange={(field, value) => setFieldValue(field, value)}
              errors={errors}
              touched={touched}
            />
          </Flex>
        </SubFormWrapper>
      )}
    </Formik>
  );
};
